<script>
import Layout from "../../layouts/main";
// import ExportButton from "@/components/export-button";
import Headers from "./table_headers";
import appConfig from "@/app.config";
import axios from "@/axios";
import moment from "moment";
import { getDateWithFormat } from "@/utils";
import DPConfig from "../../../components/dataPickerConf";
import { b64toBlob } from "@/utils";
import Filter from "../../../components/filters/Filter";
import {toExcelThree} from "../../../utils";

export default {
  page: {
    title: "Siniestros",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    // "export-button": ExportButton,
    filters: Filter,
  },
  data() {
    return {
      lang: {
        formatLocale: DPConfig.formatLocale,
      },
      tableData: [],
      fields: Headers.siniestro,
      valuePagination: {
        default: 1,
      },
      title: "Siniestros",
      daterange: [new Date("2000-01-01"), new Date()],
      rutEmpresa: "",
      patent: "",
      isBusy: false,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filtersValue: {
        patent: "",
        rutEmpresa: "",
        period: "",
      },
      filterOn: [],
      sortBy: "nroSiniestro",
      sortDesc: true,
      totRegistros: 16,
      buttonClicked: undefined,
      isBusyButtonAll: false
    };
  },
  beforeMount() {
    if (this.$route.name === "siniestrosLOP") {
      this.fields = Headers.siniestrosLOP;
      this.filtros = ["rut", "period", "patent"];
      this.filtersValue.patent = "";
    }
  },
  methods: {
    getSiniestros() {
        this.isBusy = true;
        let data;
        data = {
          rut: parseInt(this.filtersValue.rutEmpresa),
          patente: this.filtersValue.patent ? this.filtersValue.patent : "",
          fechaDesde: this.filtersValue.period[0]
            ? moment(this.filtersValue.period[0]).format("YYYY-MM-DD")
            : moment(new Date("2000-01-01")).format("YYYY-MM-DD"),
          fechaHasta: this.filtersValue.period[1]
            ? moment(this.filtersValue.period[1]).format("YYYY-MM-DD")
            : moment(new Date()).format("YYYY-MM-DD"),
        };
        axios
          .post("/GetSiniestros", data)
          .then((siniestros) => {
            this.tableData = siniestros.data.datos;
            this.totRegistros = siniestros.data.totalRegistros;
            this.isBusy = false;
          })
          .catch((error) => {
            if (error.response) {
              this.$bvToast.toast(this.$t("NoData.error.message").toString(), {
                title: this.$t("NoData.error.title").toString(),
                variant: "danger",
                solid: true,
              });
            }
            this.isBusy = false;
          });
    },
    getAllSinister() {
      this.isBusyButtonAll = true;
      let dataAll;
      dataAll = {
        rut: parseInt(this.filtersValue.rutEmpresa),
        patente: this.filtersValue.patent ? this.filtersValue.patent : "",
        fechaDesde: this.filtersValue.period[0]
            ? moment(this.filtersValue.period[0]).format("YYYY-MM-DD")
            : moment(new Date("2000-01-01")).format("YYYY-MM-DD"),
        fechaHasta: this.filtersValue.period[1]
            ? moment(this.filtersValue.period[1]).format("YYYY-MM-DD")
            : moment(new Date()).format("YYYY-MM-DD"),
        pagina: 1,
        registros: this.totRegistros,
      };
      axios
          .post("/GetSiniestros", dataAll)
          .then((Response) => {
            toExcelThree(Response.data.datos, "Siniestros_");
            this.isBusyButtonAll = false;
          })
          .catch(() => {
            this.$bvToast.toast(this.$t("NoData.error.message").toString(), {
              title: this.$t("NoData.error.title").toString(),
              variant: "danger",
              solid: true,
            });
            this.isBusyButtonAll = false;
          });
    },
    getDate(date) {
      return getDateWithFormat(date);
    },
    navigateToDetail(row) {
      this.$store.dispatch("hideValue/updateId", row.value);
      this.$store.dispatch("hideValue/updateFilter", this.filtersValue);
      this.$store.dispatch("hideValue/updatePatente", this.filtersValue.patent);
      if (this.$route.name === 'siniestrosLOP') {
        this.$router.push({ name: "siniestroDetail" });
      } else {
        this.$router.push({ name: "siniestroDetailRAC" });
      }
    },
    downloadDocumento(row) {
      this.buttonClicked = row.item.nroSiniestro;
      axios
        .get(`/GetPdfSiniestro/${this.buttonClicked}`)
        .then((doc) => {
          this.pdf = doc.data.pdf;
          if (this.pdf == null) {
            this.$bvToast.toast(this.$t("lease.pdf.error.nonFound").toString(), {
              title: this.$t("lease.pdf.error.download").toString(),
              variant: "danger",
              solid: true,
            });
            this.buttonClicked = undefined;
          } else {
            const blob = b64toBlob(this.pdf, "application/pdf");
            let fileURL = window.URL.createObjectURL(blob);
            let fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute("download", `${row.item.nroSiniestro}.pdf`);
            document.body.appendChild(fileLink);

            fileLink.click();
            this.buttonClicked = undefined;
          }
        })
        .catch(() => {
          this.$bvToast.toast(this.$t("lease.pdf.error.nonFound").toString(), {
            title: this.$t("lease.pdf.error.download").toString(),
            variant: "danger",
            solid: true,
          });
        });
    },
  },
  watch: {
    currentPage() {
      this.getSiniestros();
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-row align-h="between" align-v="center">
              <h4 class="card-tittle">Siniestros</h4>
              <div class="justify-content-end">
                <b-button v-if="$route.name !== 'siniestrosLOP'" variant="danger" href="https://web.autorentas.cl/siniestros/" target="blank">Ingresar Siniestro</b-button>
<!--                <export-button class="spacingButton" :data="tableData" fileName="Siniestros" />-->
                <b-button
                    class="spacingButton"
                    variant="danger"
                    @click="getAllSinister()"
                >
                  <template v-if="!isBusyButtonAll">Exportar</template>
                  <b-spinner v-else small class="align-middle"></b-spinner>
                </b-button>
              </div>
            </b-row>
            <filters
              v-model="filtersValue"
              @change="getSiniestros"
              patentView="getPatentsSinisterByRut"
            />
            <!-- Inicio Tabla -->
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                responsive="sm"
                :busy="isBusy"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                show-empty
              >
                <!-- Inicio Spinner en estado "ocupado" de la tabla -->
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>
                <!-- Fin Spinner en estado "ocupado" de la tabla -->

                <!-- Rows compartidos -->
                <template>
                  <h5 style="text-align: center">
                    {{ $t("request.table.empty") }}
                  </h5>
                </template>
                <template #cell(nroSiniestro)="row">
                  <a class="links" @click="navigateToDetail(row)">
                    {{ row.value }}
                  </a>
                </template>
                <template #cell(descarga)="row">
                  <div class="text-center" :id="`siniestro-${row.item.nroSiniestro}`">
                    <b-button variant="danger" @click="downloadDocumento(row)" :disabled="!row.item.nroSiniestro">
                      <i
                        v-if="buttonClicked !== row.item.nroSiniestro"
                        class="bx bx-download font-size-16 align-middle"
                      />
                      <b-spinner v-else small class="align-middle"></b-spinner>
                    </b-button>
                    <b-tooltip :target="`siniestro-${row.item.nroSiniestro}`" triggers="hover" placement="rigth" v-if="!row.item.nroSiniestro">
                      No existen documentos disponibles
                    </b-tooltip>
                  </div>
                </template>
                <template #cell(fecIngreso)="row">
                  {{ getDate(row.value) }}
                </template>
                <template #cell(fecAccidente)="row">
                  {{ getDate(row.value) }}
                </template>
                <template #cell(ingresoTaller)="row">
                  {{ row.value ? "Si" : "No" }}
                </template>
              </b-table>
              <!-- Fin Tabla -->
              <!-- Inicio Paginación -->
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination
                    @page-click="changePage"-->
                    <b-pagination
                      class="portal"
                      v-model="currentPage"
                      :per-page="perPage"
                      :total-rows="totRegistros"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
              <!-- Fin Paginación -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
a {
  cursor: pointer;
  color: blue;
}
.spacingButton{
  margin-left: 1rem;
}
</style>
